// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonKpis_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M3 0H5V12H3V0ZM0 4H2V12H0V4ZM8 2H6V7.68221C6.51203 6.91211 7.19723 6.26707 8 5.80269V2ZM11 0H9V5.34141C9.62556 5.12031 10.2987 5 11 5V0ZM16 11C16 13.419 14.2822 15.4367 12 15.9V13.8293C13.1652 13.4175 14 12.3062 14 11 14 10.8125 13.9828 10.6291 13.9499 10.4512L15.7437 9.41549C15.91 9.91341 16 10.4462 16 11ZM14.7424 7.68418C13.8265 6.6511 12.4893 6 11 6 8.23858 6 6 8.23858 6 11 6 11.3139 6.02893 11.6211 6.08428 11.919L8.00315 11.1387C8.00106 11.0927 8 11.0465 8 11 8 9.34315 9.34315 8 11 8 11.7441 8 12.4249 8.27091 12.9493 8.71948L14.7424 7.68418ZM6.83786 13.7716C7.55745 14.8501 8.68503 15.6331 10 15.9V13.8293C9.51653 13.6584 9.08994 13.3671 8.75627 12.9914L6.83786 13.7716Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonKpis is a generated icon component.
 */
let IconCommonKpis = IconCommonKpis_1 = class IconCommonKpis extends IconBaseElement {
    render() {
        return html `${IconCommonKpis_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonKpis.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s16IconSvg],
    ['s32', _s16IconSvg],
    ['s40', _s16IconSvg],
    ['s48', _s16IconSvg],
    ['s64', _s16IconSvg],
    ['s72', _s16IconSvg],
    ['s80', _s16IconSvg],
]);
IconCommonKpis = IconCommonKpis_1 = __decorate([
    customElement('zui-icon-common-kpis')
], IconCommonKpis);
export { IconCommonKpis };
